export const tenantsEn = {
  tenants: {
    onboarding: {
      title: 'Set up your workspace',
      subtitle: 'AI Workspace is multi-tenant. Create or select a workspace to continue.',
      createTitle: 'Create a workspace',
      createSubtitle: 'A workspace groups your chats, memories, and integrations.',
      selectTitle: 'Choose a workspace',
      selectSubtitle: 'You belong to multiple workspaces. Pick one to continue.',
      name: 'Workspace name',
      namePlaceholder: 'Acme Team',
      description: 'Description',
      descriptionPlaceholder: 'Optional — what is this workspace for?',
      createAction: 'Create workspace',
      selectAction: 'Continue',
      role: 'Role: {role}',
      created: 'Workspace ready',
      createFailed: 'Could not create workspace',
      selectFailed: 'Could not switch workspace',
      loading: 'Loading workspaces…',
    },
  },
}
